var d1 = "/static/1437bdd5b48bc58e.png";

export { d1 as default };
//# sourceMappingURL=d_1.png.js.map
